(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["market-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    /* One delegated listener for every instance on the page. The theme loads this file's
       javascript tag once, however many times the snippet renders, and the guard keeps a
       second bundle include from adding a second listener. */
    if (window.__gripitMarketSwitcher) return;
    window.__gripitMarketSwitcher = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      var option = target && target.closest ? target.closest('[data-market-switcher-option]') : null;
      if (!option) return;

      var form = option.form || option.closest('form');
      if (!form) return;

      var country = option.getAttribute('data-country');
      var countryInput = form.querySelector('[data-market-switcher-country]');
      if (countryInput && country) countryInput.value = country;

      /* A deliberate market choice also settles the geolocator popup: cookie for this
         domain, and a ?geolocation param on return_to so the destination domain sets
         its own cookie too. Harmless when the geolocator section is disabled. */
      if (country) {
        document.cookie = 'geolocation=' + country + ';max-age=2592000;path=/;SameSite=Lax';

        var returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          form.appendChild(returnTo);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('geolocation', country);
        returnTo.value = url.pathname + url.search;
      }
      /* No preventDefault: the submit button itself carries name="language_code". */
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__tennisBallsBackgroundInit) return;
    window.__tennisBallsBackgroundInit = true;

    const tennisBallSvg = `
      <svg viewBox="0 0 100 100" role="presentation" focusable="false" aria-hidden="true">
        <circle cx="50" cy="50" r="46" fill="currentColor" />
        <ellipse cx="40" cy="33" rx="18" ry="12" fill="rgba(255,255,255,0.12)" />
        <path d="M 18 24 C 38 40, 38 60, 18 76" fill="none" stroke="rgba(60,80,0,0.4)" stroke-width="4" stroke-linecap="round" />
        <path d="M 82 24 C 62 40, 62 60, 82 76" fill="none" stroke="rgba(60,80,0,0.4)" stroke-width="4" stroke-linecap="round" />
      </svg>
    `;

    // Seeded PRNG (mulberry32) — always produces the same sequence from the same seed
    const SEED = 0x4a3b2c1d;
    const createRng = (seed) => {
      let s = seed >>> 0;
      return () => {
        s = Math.imul(s ^ (s >>> 15), s | 1);
        s ^= s + Math.imul(s ^ (s >>> 7), s | 61);
        return ((s ^ (s >>> 14)) >>> 0) / 0xffffffff;
      };
    };

    const MOBILE_BREAKPOINT = 750;
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const placeBalls = (container, isMobile) => {
      container.innerHTML = '';

      const rng = createRng(SEED);
      const rand = (min, max) => min + rng() * (max - min);

      const width = Math.max(120, container.offsetWidth);
      const height = Math.max(120, container.offsetHeight);
      const shortSide = Math.min(width, height);

      const minSize = isMobile ? clamp(shortSide / 10, 14, 26) : clamp(shortSide / 8, 22, 40);
      const maxSize = isMobile ? clamp(shortSide / 5, 22, 38) : clamp(shortSide / 3.5, 36, 68);

      const placed = [];
      const paddingPx = 12;

      const fitsWithoutOverlap = (candidate) => {
        for (const other of placed) {
          const dx = ((candidate.x - other.x) / 100) * width;
          const dy = ((candidate.y - other.y) / 100) * height;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < (candidate.size + other.size) / 2 + paddingPx) return false;
        }
        return true;
      };

      const clampToBounds = (x, y, size) => ({
        x: clamp(x, (size / 2 / width) * 100, 100 - (size / 2 / width) * 100),
        y: clamp(y, (size / 2 / height) * 100, 100 - (size / 2 / height) * 100)
      });

      const rawCount = Number(container.dataset.tennisBallsCount || 12);
      const safeCount = Number.isFinite(rawCount) ? Math.max(1, Math.min(36, rawCount)) : 12;
      // Desktop: 8 balls (4 per side); mobile: 6 balls (3 top, 3 bottom)
      const desktopCount = Math.min(safeCount, 14);
      const mobileCount = 6;
      const count = isMobile ? mobileCount : desktopCount;
      const half = Math.ceil(count / 2);

      // Zone picker: deterministic per index
      // Desktop → both side strips combined, placed with best-candidate algorithm
      //           (Mitchell's best-candidate: pick the position most distant from all others)
      // Mobile  → top/bottom strips, slotted horizontally so balls spread across the full width
      const mobileXSlots = half;
      const slotWidthPct = 100 / mobileXSlots;

      const desktopCandidate = (size) => {
        // Pick left or right strip, alternating so sides stay balanced
        const onLeft = placed.filter(p => p.x < 50).length <= placed.filter(p => p.x >= 50).length;
        // Left side: bias toward the edge — most balls hug 4–20%, a few reach to 30%
        const x = onLeft
          ? (rand(0, 1) < 0.65 ? rand(4, 20) : rand(20, 30))
          : rand(64, 97);
        const y = rand(0, 100);
        return clampToBounds(x, y, size);
      };

      const minDistToPlaced = (candidate) => {
        let minD = Infinity;
        for (const other of placed) {
          const dx = ((candidate.x - other.x) / 100) * width;
          const dy = ((candidate.y - other.y) / 100) * height;
          minD = Math.min(minD, Math.sqrt(dx * dx + dy * dy));
        }
        return minD;
      };

      const getZoneXY = (i, size) => {
        const inFirstZone = i < half;
        if (isMobile) {
          const xSlotIndex = inFirstZone ? i : i - half;
          const xSlotLeft = xSlotIndex * slotWidthPct;
          const xJitter = slotWidthPct * 0.15;
          const x = rand(xSlotLeft + xJitter, xSlotLeft + slotWidthPct - xJitter);
          const y = inFirstZone ? rand(0, 26) : rand(74, 100);
          return clampToBounds(x, y, size);
        } else {
          // Best-candidate: try 15 positions, keep the one furthest from all placed balls
          let best = null;
          let bestDist = -1;
          for (let k = 0; k < 15; k += 1) {
            const c = desktopCandidate(size);
            const d = placed.length === 0 ? Infinity : minDistToPlaced(c);
            if (d > bestDist) { bestDist = d; best = c; }
          }
          return best;
        }
      };

      for (let i = 0; i < count; i += 1) {
        // Pre-generate all rng values for this ball so a failed attempt
        // doesn't desync the sequence — we use a fixed set of values per index
        const size = rand(minSize, maxSize);
        const duration = rand(4, 10);
        const delay = rand(-6, 0);
        const dx1 = rand(-18, 18);
        const dy1 = rand(-18, 18);
        const dx2 = rand(-18, 18);
        const dy2 = rand(-18, 18);
        const rot1 = rand(-18, 18);
        const rot2 = rand(-18, 18);
        // Smaller balls get lower opacity so they feel further in the background
        const sizeRange = maxSize - minSize || 1;
        const sizeFraction = (size - minSize) / sizeRange; // 0 = smallest, 1 = largest
        const alpha = 0.32 + sizeFraction * 0.58; // small→0.32, large→0.90

        let placedBall = null;
        // Try the zone first, then progressively relax
        for (let attempt = 0; attempt < 300; attempt += 1) {
          // All attempts stay within the zone — no center fallback that could hit the text
          const { x, y } = attempt < 80
            ? getZoneXY(i, size)
            : isMobile
              ? getZoneXY(i, size)
              : clampToBounds(rand(0, 1) < 0.5 ? (rand(0, 1) < 0.65 ? rand(4, 20) : rand(20, 30)) : rand(64, 97), rand(0, 100), size);

          const candidate = { x, y, size };
          if (!fitsWithoutOverlap(candidate)) continue;

          placed.push(candidate);
          placedBall = candidate;
          break;
        }

        if (!placedBall) continue;

        const ball = document.createElement('span');
        ball.className = 'tennis-ball';
        ball.innerHTML = tennisBallSvg;

        ball.style.setProperty('--x', String(placedBall.x.toFixed(2)));
        ball.style.setProperty('--y', String(placedBall.y.toFixed(2)));
        ball.style.setProperty('--size', String(size.toFixed(2)));
        ball.style.setProperty('--duration', `${duration.toFixed(2)}s`);
        ball.style.setProperty('--delay', `${delay.toFixed(2)}s`);
        ball.style.setProperty('--dx1', `${dx1.toFixed(2)}px`);
        ball.style.setProperty('--dy1', `${dy1.toFixed(2)}px`);
        ball.style.setProperty('--dx2', `${dx2.toFixed(2)}px`);
        ball.style.setProperty('--dy2', `${dy2.toFixed(2)}px`);
        ball.style.setProperty('--rot1', `${rot1.toFixed(2)}deg`);
        ball.style.setProperty('--rot2', `${rot2.toFixed(2)}deg`);
        ball.style.setProperty('--alpha', String(alpha.toFixed(2)));

        container.appendChild(ball);
      }
    };

    const initContainer = (container) => {
      if (!container || container.dataset.tennisBallsObserved === 'true') return;
      container.dataset.tennisBallsObserved = 'true';

      let lastIsMobile = null;

      const render = () => {
        const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
        // Only re-place when layout zone actually changes (desktop ↔ mobile)
        if (isMobile === lastIsMobile) return;
        lastIsMobile = isMobile;
        placeBalls(container, isMobile);
      };

      const ro = new ResizeObserver(() => requestAnimationFrame(render));
      ro.observe(container);
      requestAnimationFrame(render);
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-tennis-balls]').forEach(initContainer);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      requestAnimationFrame(() => initAll());
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
